export const AuthInitialState: AuthTypes = {
  jwtToken: null,
  userId: null,
  error: null,
  tokenVerification: null,
};
